import React, {useEffect, useState} from 'react';
import {mostrarAgentes} from '../../redux/reducers/agentesReducers';
import {
    Avatar,
    Button,
    Divider,
    List,
    ListItemAvatar,
    ListItemButton,
    ListItemText,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Theme,
    Typography,
    useMediaQuery
} from "@mui/material";
import Strings from "../../assets/strings"
import {AppBar, Empty, ListViewMode, LoadingProgress, PlusFab, SeacrhAppBar} from "../../components";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import {ReactComponent as EmptySvg} from "../../assets/img/collaborators.svg";
import {useAppDispatch, useAppSelector} from "../../redux/hooks";
import CrearAgente from "./CrearAgente";
import {translateText} from "../../helpers";

const initialState={
    name:'',
}
function  Agentes() {
    const navigate =useNavigate();
    const location = useLocation();
    let { farId:urlFarId } = useParams()

    const { list, status,filtered} = useAppSelector(state => state.agentes);

    const Dispatch = useAppDispatch();
    const [filter, setFilter] = useState(initialState);


    const smVewport = useMediaQuery((theme:Theme)=>theme.breakpoints.down('md'));
    useEffect(() => {
            Dispatch(mostrarAgentes());
    }, [Dispatch, urlFarId])

    
    //set filtered params
    useEffect(()=>setFilter({...initialState,...filtered}),[setFilter,filtered])


    const handleFilter = (e:React.ChangeEvent<HTMLInputElement>) => {
        const {name, value, type, checked} = e.target;
        if(name === "name" || name === "page" || name === "pageSize") return Dispatch(mostrarAgentes({...filter,[name]:value}));

        setFilter(prevState => ({...prevState,[name]:type === "checkbox"?checked:value}))
    };


    return(
        <>
            <AppBar />
            <section className="contentInner" style={status === "loading"?{opacity:.8}:{opacity:1}}>
                {status === "loading" && <LoadingProgress vh/>}



                <ListViewMode pageRows={list?.length} pageTotalRows={list?.length}>
                    <SeacrhAppBar name="name" value={filter.name} onChange={handleFilter}/>
                </ListViewMode>

                { smVewport ? (
                    <List>
                        {list?.map(agente => (
                            <React.Fragment key={agente.id}>
                                <ListItemButton alignItems="flex-start" onClick={()=> {
                                    //   if(!hasPermissionTo(PERSMISOS.agentesActualizar)) return false;
                                    navigate(location.pathname, {state:{usuario: agente}})
                                }} >
                                    <ListItemAvatar>
                                        <Avatar>{agente.nombre?.charAt(0).toUpperCase()}</Avatar>
                                    </ListItemAvatar>
                                    <ListItemText secondary={agente.rol}>
                                        <Typography noWrap className={agente.inactivo ? "text-red":""}>
                                            {agente.nombre}
                                        </Typography>
                                    </ListItemText>
                                </ListItemButton>
                                <Divider variant="inset" component="li"/>
                            </React.Fragment>
                        ))}
                    </List>
                ) : (
                    <TableContainer>
                        <Table aria-label="simple table" className={"hasOnclick"}>
                            <TableHead>
                                <TableRow>
                                    <TableCell>{Strings.nombreDeUsuario}</TableCell>
                                    <TableCell>{Strings.primerNombre}</TableCell>
                                    <TableCell>{Strings.email}</TableCell>
                                    <TableCell>{Strings.rol}</TableCell>
                                    <TableCell>{Strings.tipo}</TableCell>
                                    <TableCell>{Strings.estado}</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {list?.map(item =>
                                    <TableRow key={item.id} className={item.inactivo ? "text-red-deep":""}
                                              onClick={()=> {
                                                  //   if(!hasPermissionTo(PERSMISOS.agentesActualizar)) return false;
                                                  navigate(location.pathname, {state:{usuario: item}})
                                              }}>
                                        <TableCell> {item.inicioSesion }</TableCell>
                                        <TableCell> {item.nombre}</TableCell>
                                        <TableCell> {item.email}</TableCell>
                                        <TableCell> {item.rol}</TableCell>
                                        <TableCell> {translateText(item.tipoString)}</TableCell>
                                        <TableCell> {item.inactivo?Strings.inactivo:Strings.activo}</TableCell>

                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                )}


                {list.length === 0 &&
                        <Empty Img={EmptySvg} title={Strings.aunNoTienes+" "+Strings.agentes}>
                            <p>{Strings.agentesHelpMsj}</p>
                        </Empty>
                }
                {/*{hasPermissionTo(PERSMISOS.agentesCrear) &&*/}
                    <PlusFab component={Button} onClick={()=>navigate(location.pathname,{state:{usuario:{id:""}}})} />
                {/*}*/}
                <CrearAgente/>
            </section>
        </>
    )


}
export default Agentes;
